(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  function initBeforeAfterSliders(root) {
    root.querySelectorAll('[data-ba-slider]').forEach(function (slider) {
      if (slider.dataset.baInit) return;
      slider.dataset.baInit = 'true';

      var clip = slider.querySelector('[data-ba-clip]');
      var handle = slider.querySelector('[data-ba-handle]');
      var range = slider.querySelector('[data-ba-range]');
      var dragging = false;

      function setPosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        clip.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
        handle.style.left = percent + '%';
        range.value = percent;
      }

      function positionFromClientX(clientX) {
        var rect = slider.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      var basePercent = parseFloat(range.value);
      setPosition(basePercent);

      // Glissement sur toute la zone (souris + tactile) — fonctionne sur mobile
      slider.addEventListener('pointerdown', function (e) {
        dragging = true;
        slider.classList.add('is-dragging');
        clearInterval(shakeTimer);
        slider.setPointerCapture(e.pointerId);
        setPosition(positionFromClientX(e.clientX));
      });
      slider.addEventListener('pointermove', function (e) {
        if (dragging) setPosition(positionFromClientX(e.clientX));
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        slider.addEventListener(evt, function () {
          dragging = false;
          slider.classList.remove('is-dragging');
        });
      });

      range.addEventListener('input', function (e) {
        clearInterval(shakeTimer);
        setPosition(parseFloat(e.target.value));
      });

      // Petit shake toutes les 5 secondes (+/-5%) pour rappeler que la barre se glisse,
      // tant que le visiteur n'a pas encore interagi lui-même
      function shake() {
        if (dragging) return;
        setPosition(basePercent - 5);
        setTimeout(function () {
          setPosition(basePercent + 5);
          setTimeout(function () { setPosition(basePercent); }, 250);
        }, 250);
      }
      var shakeTimer = setInterval(shake, 5000);
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initBeforeAfterSliders(document); });
  document.addEventListener('shopify:section:load', function (e) { initBeforeAfterSliders(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dualsplit"] && !Shopify.designMode) return;
  try {
    
(function () {
  var containers = document.querySelectorAll('[id^="ds-"]');

  containers.forEach(function (container) {
    var cells = container.querySelectorAll('.ds-cell');
    if (cells.length < 2) return;

    var intervalSeconds = parseFloat(container.dataset.mobileInterval) || 5;
    var intervalMs = intervalSeconds * 1000;
    var current = 0;
    var timer = null;
    var mql = window.matchMedia('(max-width: 767px)');

    function showNext() {
      cells[current].classList.remove('is-active');
      current = (current + 1) % cells.length;
      cells[current].classList.add('is-active');
    }

    function start() {
      if (timer) return;
      timer = setInterval(showNext, intervalMs);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function handleChange() {
      if (mql.matches) {
        start();
      } else {
        stop();
      }
    }

    handleChange();
    mql.addEventListener('change', handleChange);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jacqum-collect"] && !Shopify.designMode) return;
  try {
    
(function () {

  // ── Swatch swap ──
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.media-grid__swatch-item');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    var cell = swatch.closest('.media-grid__cell');
    if (!cell) return;
    var mainImg = cell.querySelector('.media-grid__img--main');
    if (mainImg && swatch.dataset.image) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = swatch.dataset.image;
    }
    cell.querySelectorAll('.media-grid__swatch-item').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  });

  // ── Détection touch réelle ──
  var isTouchDevice = false;
  window.addEventListener('touchstart', function () {
    isTouchDevice = true;
  }, { once: true, passive: true });

  document.addEventListener('click', function (e) {
    if (!isTouchDevice) return;

    var link = e.target.closest('.media-grid__link');

    // tap hors grille = reset
    if (!link) {
      if (!e.target.closest('.media-grid__cell')) {
        document.querySelectorAll('.media-grid__cell.is-tapped').forEach(function (c) {
          c.classList.remove('is-tapped');
        });
      }
      return;
    }

    var cell = link.closest('.media-grid__cell');
    if (!cell || !cell.dataset.productUrl) return;

    if (!cell.classList.contains('is-tapped')) {
      e.preventDefault();
      document.querySelectorAll('.media-grid__cell.is-tapped').forEach(function (c) {
        c.classList.remove('is-tapped');
      });
      cell.classList.add('is-tapped');
    }
    // 2e tap = navigation normale
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
